import restConnector from "./RestConnector";
import { generateDeviceToken } from "./Utils";

const Auth = {
  login: async (email, password) => {
    const deviceToken = await generateDeviceToken();
    const resp = await restConnector.post("/users/login?include=user", {
      email,
      password,
      deviceToken
    });
    if (resp.data.user.role !== "admin") {
      throw new Error("Permission denied");
    }
    restConnector.accessToken = resp.data.id;
    return resp.data.user;
  },

  logout: async () => {
    await restConnector.post("/users/logout");
    restConnector.accessToken = null;
  },

  getCurrentUser: async () => {
    const resp = await restConnector.get("/users/me");
    return resp.data;
  },

  resetPassword: async email => {
    await restConnector.post("/users/reset", { email });
  },

  changePassword: async (newPassword, token) => {
    await restConnector.post(`/users/reset-password?access_token=${token}`, {
      newPassword
    });
  }
};

export default Auth;



// WEBPACK FOOTER //
// client/lib/Auth.js